import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import logo from "../../Assets/green.png";
import cartIcon from "../../Assets/cart.svg";
import shareIcon from "../../Assets/share.png";

import classes from "./Aff.module.css";
import { getAffiliationById } from "../../Store/AffReducer/affSlice";

export default function AffHome() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const data = useSelector((state) => state.aff.affiliation);
  const products = useSelector((state) => state.aff.products || []);

  useEffect(() => {
    if (id) {
      dispatch(getAffiliationById(id));
    }
  }, [id, dispatch]);

  const handleShare = async (product) => {
    const productName = product.nameArabic || product.name;
    const productUrl = product.productUrl;

    try {
      if (navigator.share) {
        await navigator.share({
          title: productName,
          text: `تعرّف على ${productName}`,
          url: productUrl,
        });
      } else {
        await navigator.clipboard.writeText(productUrl);
        alert("تم نسخ رابط المنتج");
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("تعذرت مشاركة المنتج:", error);
      }
    }
  };

  const getBadgeColor = (index) => {
    if (index === 0) return "#f94144";
    if (index === 1) return "#f8961e";
    if (index === 2) return "#43aa8b";

    return "#4C4646";
  };

  return (
    <div className={classes.page} dir="rtl" lang="ar">
      <div className={classes.container}>
        <img
          src={logo}
          alt="شعار الموقع"
          className={classes.logo}
        />

        <p className={classes.description}>
          أبحاث يقودها صيادلة لتقديم توصيات موثوقة حول المكملات الغذائية،
          اعتمادًا على الأدلة العلمية، وجودة المكونات، وسمعة العلامات
          التجارية، وتجارب العملاء الحقيقية.
        </p>
      </div>

      <div className={classes.productHead}>
        <h2>
          {data?.nameArabic ||
            data?.arabicName ||
            data?.name ||
            "أفضل المكملات الغذائية"}
        </h2>
      </div>

      <div className={classes.products}>
        {products.map((product, index) => {
          const productName =
            product.nameArabic ||
            product.arabicName ||
            product.name;

          const productDescription =
            product.descriptionArabic ||
            product.arabicDescription ||
            product.description;

          const productOrigin =
            product.originArabic ||
            product.arabicOrigin ||
            product.origin;

          return (
            <article
              key={product.id}
              className={classes.product}
            >
              <div className={classes.imageContainer}>
                <div
                  className={classes.topPicked}
                  style={{
                    backgroundColor: getBadgeColor(index),
                  }}
                >
                  #{index + 1}
                </div>

                <img
                  src={product.imageUrl}
                  alt={productName}
                  className={classes.productImage}
                />
              </div>

              <div className={classes.productContent}>
                <h3 className={classes.productName}>
                  {productName}
                </h3>

                <div className={classes.ratingRow}>
                  <span className={classes.ratingScore}>
                    {product.score}
                  </span>

                  <span className={classes.ratingLabel}>
                    بلد المنشأ:
                  </span>

                  <p className={classes.productMadeIn}>
                    {productOrigin}
                  </p>
                </div>

                <p className={classes.productReason}>
                  {productDescription}
                </p>

                <div className={classes.buttonContainer}>
                  <a
                    href={product.productUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.buyButton}
                    aria-label={`احصل على ${productName}`}
                  >
                    <img
                      src={cartIcon}
                      alt=""
                      aria-hidden="true"
                      className={classes.buttonIcon}
                    />

                    <span>احصل عليه الآن</span>
                  </a>

                  <button
                    type="button"
                    className={classes.shareButton}
                    onClick={() => handleShare(product)}
                    aria-label={`مشاركة ${productName}`}
                    title="مشاركة المنتج"
                  >
                    <img
                      src={shareIcon}
                      alt=""
                      aria-hidden="true"
                      className={classes.shareIcon}
                    />
                  </button>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}